export const CaseStudyDataTranslated = {
    pt: [
        {
            "id": 1,
            "thumb": "/images/icon/icon-29.png",
            "title": "Organize com antecedência",
            "subtitle": "Dica #1",
            "excerpt": "Cada mudança é sempre um motivo de preocupação, assim sendo, organize a sua mudança com calma, não deixe tudo para a última hora!"
        },
        {
            "id": 2,
            "thumb": "/images/icon/icon-28.png",
            "title": "Numere as caixas",
            "subtitle": "Dica #2",
            "excerpt": "Comece por numerar as caixas e faça uma lista do que cada uma contêm. Isso vai facilitar organizar na nova morada."
        },
        {
            "id": 3,
            "thumb": "/images/icon/icon-31.png",
            "title": "Cuidado com o Frágil",
            "subtitle": "Dica #3",
            "excerpt": "Ao embalar, mencione \"frágil\" nas caixas com objetos que necessitem de uma maior atenção durante a mudança e transporte."
        },
        {
            "id": 4,
            "thumb": "/images/icon/icon-27.png",
            "title": "Eletrodomésticos",
            "subtitle": "Dica #4",
            "excerpt": "Frigoríficos e arcas congeladoras devem ser desligados da corrente elétrica 24 horas antes da mudança. As mudanças deste tipo de eletrodomésticos são efetuadas sem produtos no seu interior."
        },
        {
            "id": 5,
            "thumb": "/images/icon/icon-11.png",
            "title": "Mobiliário com conteúdo",
            "subtitle": "Dica #5",
            "excerpt": "Tenha em conta que por vezes existe mobiliário que não justifica retirar do seu interior os seus bens devido ao peso ser pouco significativo. Por exemplo, uma cómoda de reduzidas dimensões e com roupas no interior."
        },
        {
            "id": 6,
            "thumb": "/images/icon/icon-32.png",
            "title": "Destinos diferentes",
            "subtitle": "Dica #6",
            "excerpt": "Caso verifique a existência de mobiliário para transporte com destinos diferentes, por favor organize a separação etiquetando os mesmos de forma a facilitar o serviço de mudança e transporte."
        },
        {
            "id": 7,
            "thumb": "/images/icon/icon-14.png",
            "title": "Livros",
            "subtitle": "Dica #7",
            "excerpt": "Coloque os livros em caixas pequenas para evitar o peso excessivo, certifique-se sempre que as caixas estão fechadas por baixo."
        },
        {
            "id": 8,
            "thumb": "/images/icon/icon-33.png",
            "title": "Plantas",
            "subtitle": "Dica #8",
            "excerpt": "Evite regar as plantas 24h/48h antes da viagem pois a água cria mais peso e fragiliza os vasos tornando-os mais fáceis de partir."
        },
        {
            "id": 9,
            "thumb": "/images/icon/icon-34.png",
            "title": "Estacionamento",
            "subtitle": "Dica #9",
            "excerpt": "Tenha sempre em consideração um local de estacionamento mais perto possível para se proceder à carga e descarga. Lembre-se que a via pública tem limitações para este efeito."
        },
        {
            "id": 10,
            "thumb": "/images/icon/icon-35.png",
            "title": "Verificação Final",
            "subtitle": "Dica #10",
            "excerpt": "Antes da mudança iniciar o seu transporte, verifique todas as divisões de forma a não deixar nada na antiga morada. Após a mudança terminar, verifique se ficou algum objeto esquecido."
        }
    ],
    en: [
        {
            "id": 1,
            "thumb": "/images/icon/icon-29.png",
            "title": "Organize in advance",
            "subtitle": "Tip #1",
            "excerpt": "Every move is always a cause for concern, so organize your move calmly, don't leave everything to the last minute!"
        },
        {
            "id": 2,
            "thumb": "/images/icon/icon-28.png",
            "title": "Number the boxes",
            "subtitle": "Tip #2",
            "excerpt": "Start by numbering the boxes and make a list of what each one contains. This will make it easier to organize at the new address."
        },
        {
            "id": 3,
            "thumb": "/images/icon/icon-31.png",
            "title": "Be careful with Fragile items",
            "subtitle": "Tip #3",
            "excerpt": "When packing, mention \"fragile\" on boxes with objects that require greater attention during the move and transport."
        },
        {
            "id": 4,
            "thumb": "/images/icon/icon-27.png",
            "title": "Appliances",
            "subtitle": "Tip #4",
            "excerpt": "Refrigerators and freezers must be disconnected from the power supply 24 hours before moving. Moves of this type of appliance are carried out without products inside."
        },
        {
            "id": 5,
            "thumb": "/images/icon/icon-11.png",
            "title": "Furniture with contents",
            "subtitle": "Tip #5",
            "excerpt": "Keep in mind that sometimes there is furniture that does not justify removing its contents from the inside due to the weight being insignificant. For example, a small dresser with clothes inside."
        },
        {
            "id": 6,
            "thumb": "/images/icon/icon-32.png",
            "title": "Different destinations",
            "subtitle": "Tip #6",
            "excerpt": "If you notice the existence of furniture for transport with different destinations, please organize the separation by labeling them in order to facilitate the moving and transport service."
        },
        {
            "id": 7,
            "thumb": "/images/icon/icon-14.png",
            "title": "Books",
            "subtitle": "Tip #7",
            "excerpt": "Place books in small boxes to avoid excessive weight, always make sure the boxes are closed at the bottom."
        },
        {
            "id": 8,
            "thumb": "/images/icon/icon-33.png",
            "title": "Plants",
            "subtitle": "Tip #8",
            "excerpt": "Avoid watering plants 24h/48h before the trip as the water creates more weight and weakens the pots making them easier to break."
        },
        {
            "id": 9,
            "thumb": "/images/icon/icon-34.png",
            "title": "Parking",
            "subtitle": "Tip #9",
            "excerpt": "Always consider a parking space as close as possible to carry out loading and unloading. Remember that public roads have limitations for this purpose."
        },
        {
            "id": 10,
            "thumb": "/images/icon/icon-35.png",
            "title": "Final Check",
            "subtitle": "Tip #10",
            "excerpt": "Before the move starts its transport, check all the rooms so as not to leave anything at the old address. After the move is finished, check if any objects were left behind."
        }
    ]
};

